import React from 'react';
// Images
import SammiMainImage from '../../assets/images/noBackground/mistress-sammi-smith-trans-dominatrix-no-background-with-whip.png';
import SammiSmithLogo from '../../assets/images/logos/mistress-sammi-smith-pink-logo.png';
// Constants
import {
  CompanyTagLine,
  CompanyName,
  MainTitle,
  SubtitleMain,
} from '../../utils/Constants';
import {
  CONTACT_PAGE_URL,
} from '../../utils/Routes';
import { Link } from 'react-router-dom';

function HomePageHeader() {
  return (
    <header className='grid grid-rows-reg lg:grid-rows-[2fr_1fr] pt-6 overflow-hidden h-full w-full'>
      <section className='grid h-fit lg:-mt-4'>
        <div>
          <img
            src={SammiMainImage}
            alt={`${CompanyName} welcomes you.`}
            className='mx-auto md:-mb-6 max-w-[80vw] max-h-[40vh] lg:max-h-[45vh]'
          />
        </div>
        <div>
          <img
            src={SammiSmithLogo}
            alt={`${CompanyName} logo.`}
            className='mx-auto -mt-16 lg:-mt-20 md:max-w-[60vw] xl:max-w-[50vw] 2xl:max-w-[40vw]'
          />
        </div>
      </section>
      <section className='grid container mx-auto px-4 h-full w-full'>
        <article className='grid my-2 lg:-mt-2'>
          <div className='grid h-fit gap-1'>
            <article className='border-2 border-solid md:-mt-2 mb-2 border-colour1 w-fit mx-auto px-4 lg:px-8 py-1 rounded-full shadow-cardShadow'>
              <h1 className='font-semibold md:text-xl'>{MainTitle}</h1>
            </article>
            <h2 className='text-lg text-center leading-5 text-colour1 dark:text-colour1'>
              {SubtitleMain}
            </h2>
            <h3 className='text-lg text-center leading-5 text-colour1 dark:text-colour1'>
              {CompanyTagLine}
            </h3>
          </div>

          <aside className='mx-auto lg:-mt-12'>
            <Link
              to={CONTACT_PAGE_URL}
              className='blinking-button active:scale-90'
              title='Contact me'
              aria-label='Contact form page link'
            >
              Book a Session
            </Link>
          </aside>
        </article>
      </section>
    </header>
  );
}

export default HomePageHeader;
